import type { EndpointDefinition } from "../../_sdk/types/common";

export const apiName = "workspaces";

export const endpoints: { [key: string]: EndpointDefinition } = {
    parseSamlMetadata: {
        route: "/workspaces/:workspaceId/parse-saml-metadata",
        method: "POST"
    },
    verifyWorkspaceDomain: {
        route: "/workspaces/:workspaceId/verify-domain",
        method: "POST"
    },
    addWorkspaceDomain: {
        route: "/workspaces/:workspaceId/add-domain",
        method: "POST"
    },
    removeWorkspaceDomain: {
        route: "/workspaces/:workspaceId/remove-domain",
        method: "POST"
    },
    connectWorkspaceIntegration: {
        route: "/workspaces/:workspaceId/integrations/:integrationType/connect",
        method: "POST"
    },
    disconnectWorkspaceIntegration: {
        route: "/workspaces/:workspaceId/integrations/:integrationType/disconnect",
        method: "POST"
    }
};
